module.exports = __webpack_public_path__ + "static/media/vg_activated.8f633e44.svg";